<template>
  <div class="agent-manager" style="display: flex;">
    <!-- Left: List Table -->
    <div style="flex: 4; padding: 24px 0 0px 24px;    background: rgb(101, 101, 101);border-radius: 20px;    margin-right: 10px;   text-align: left;">
      <!-- Search Bar -->
      <el-input
        placeholder="输入昵称或VXID查找代理"
        prefix-icon="el-icon-search"
        v-model="search"
        clearable
        class="round-input"
        style="margin-bottom: 12px; width: 360px;"
      />
      <!-- Table -->
      <el-table
        :data="filteredAgents"
        border
        height="calc(100vh - 180px)"
        style="width: 100%; background: rgb(101, 101, 101); color: #fff;"
        @row-click="handleRowClick"
        :row-class-name="tableRowClassName"
      >
        <el-table-column prop="nick_name" label="代理昵称" ></el-table-column>
        <el-table-column prop="wx_id" label="代理ID" ></el-table-column>
        <el-table-column prop="count" label="群数量" sortable></el-table-column>
        <el-table-column prop="expire_time" label="到期时间" sortable></el-table-column>
        <el-table-column label="代理类型">
          <template slot-scope="scope">
            {{ formatType(scope.row.type) }}
          </template>
        </el-table-column>
        <el-table-column prop="recharge_amount" label="余额" sortable :sort-method="sortRechargeAmount"></el-table-column>
      </el-table>
    </div>

    <!-- Right: Form Panel-->
    <div style="flex: 1; border-radius: 16px;">
      <!-- Add Agent Form -->
      <div style="font-size: 18px; font-weight: bold; margin-bottom: 8px;">
          <i class="el-icon-plus"></i> 添加代理
        </div>
      <el-card shadow="never" style="background: #656565; color: #fff; margin-bottom: 16px;">
        
        <el-form :model="addForm" label-width="80px">
          <el-form-item label="代理昵称">
            <el-input size="small" v-model="addForm.nick_name" placeholder="请输入代理昵称" />
          </el-form-item>
          <el-form-item label="代理VXID">
            <el-input size="small"  v-model="addForm.wx_id" placeholder="请输入代理ID" />
          </el-form-item>
          <el-form-item label="代理类型">
            <el-select size="small"  v-model="addForm.type" placeholder="请选择代理类型">
              <el-option v-for="item in types" :key="item.val" :label="item.name" :value="item.val" />
            </el-select>
          </el-form-item>
          <el-form-item label="充值金额">
            <el-input size="small"  v-model="addForm.recharge_amount" placeholder="请输入充值金额" />
          </el-form-item>
          <el-form-item label="到期时间">
            <el-date-picker size="small"  v-model="addForm.expire_time" type="date" placeholder="到期时间" style="width: 100%;" />
          </el-form-item>
          <div>
            <el-button size="small"  type="primary" @click="addProxy">确认添加</el-button>
          </div>
        </el-form>
      </el-card>
      <!-- Edit Agent Form -->
      <div style="font-size: 18px; font-weight: bold; margin-bottom: 8px;">
          <i class="el-icon-edit"></i> 修改代理详情
        </div>
      <el-card shadow="never" style="background: #656565; color: #fff;">
        
        <el-form :model="editForm" label-width="80px">
          <el-form-item label="代理昵称">
            <span>{{ editForm.nick_name || '请选择' }}</span>
          </el-form-item>
          <el-form-item label="代理VXID">
            <span>{{ editForm.wx_id || '请选择' }}</span>
          </el-form-item>
          <el-form-item label="代理类型">
            <el-select size="small" v-model="editForm.type" placeholder="请选择代理类型">
              <el-option v-for="item in types" :key="item.val" :label="item.name" :value="item.val" />
            </el-select>
          </el-form-item>
          <el-form-item label="代理余额">
            <el-input size="small" v-model="editForm.recharge_amount" placeholder="请输入余额" />
          </el-form-item>
          <el-form-item label="到期时间">
            <el-date-picker size="small" v-model="editForm.expire_time" type="date" placeholder="到期时间" style="width: 100%;" />
          </el-form-item>
          <div>
            <el-button size="small" type="danger" @click="deleteAgent">删除代理</el-button>
            <el-button size="small" type="primary" @click="updateProxy" style="margin-left: 12px;">确认修改</el-button>
          </div>
        </el-form>
      </el-card>
    </div>
  </div>
</template>

<script>
export default {
  name:"PowerPage",
  data() {
    return {
      selectedRowId: null,
      search: '',
      types: [
        {name:"储值代理",val:1},{name:"月结代理",val:2}],
      agents: [
      ],
      addForm: {
        nick_name: '',
        wx_id: '',
        type: '',
        recharge_amount: '',
        expire_time: ''
      },
      editForm: {
        nick_name: '',
        wx_id: '',
        type: '',
        recharge_amount: '',
        expire_time: ''
      }
    }
  },
  computed: {
    // filteredAgents() {
    //   if (!this.search) return this.agents;
    //   return this.agents.filter(agent =>
    //     agent.name.includes(this.search) || agent.vxid.includes(this.search)
    //   );
    // }
    filteredAgents() {
      if (!this.search) return this.agents;

      const keyword = this.search.toLowerCase().trim();
      return this.agents.filter(agent => {
        const name = (agent.nick_name || '').toLowerCase();
        const wxid = (agent.wx_id || '').toLowerCase();
        return name.includes(keyword) || wxid.includes(keyword);
      });
    }
  },
  methods: {
    handleRowClick(row) {
      console.log(row)
      this.selectedRowId = row.id;
      // 选中后把这行数据放到 editForm
      this.editForm = {
        ...row
      };
    },
    tableRowClassName({ row }) {
      return row.id === this.selectedRowId ? 'selected-row' : '';
    },
    formatType(val) {
      const found = this.types.find(item => item.val === val);
      console.log(found)
      return found ? found.name : val;
    },
    sortRechargeAmount(a, b) {
      // 把字符串转成数字，防止空字符串或异常
      const valA = parseFloat(a.recharge_amount) || 0;
      const valB = parseFloat(b.recharge_amount) || 0;
      return valA - valB;
    },
    async proxyList(){
      try {
        const res = await this.$axios.post('/proxy/list', {
          'search':this.search
        })
        this.agents = res.data;
      } catch (err) {
        console.log(err);
      }
    },
    async addProxy() {
      try {
        console.log(this.addForm)
        const res = await this.$axios.post('/proxy/create', {
          ...this.addForm
        })
        if(res.code == 200){
          this.addForm = []
          this.proxyList()

        }
        console.log(res);
      } catch (err) {
        console.log(err);
      }
    },
    async updateProxy() {

      try {
        console.log(this.addForm)
        await this.$axios.post('/proxy/update', {
          ...this.editForm
        })
        this.proxyList();

      } catch (err) {
        console.log(err)
      }
    },
    async deleteAgent() {
      console.log(this.editForm)
      if (!this.editForm.id) {
        this.$message.warning('请先选择要删除的代理');
        return;
      }

      try {
        await this.$confirm(
          `确认要删除代理【${this.editForm.nick_name}】吗？`,
          '提示',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }
        );

        const res = await this.$axios.post('/proxy/delete', {
          id: this.editForm.id
        });

        if (res.code === 200) {
          this.$message.success('删除成功');
          this.editForm = { nick_name: '', wx_id: '', type: '', recharge_amount: '', expire_time: '' };
          this.proxyList();
        } else {
          this.$message.error('删除失败：' + res.msg);
        }
      } catch (err) {
        if (err !== 'cancel') {
          console.log(err);
          this.$message.error('删除异常');
        }
      }
    }

  },
  watch: {
    // 选中左侧表格某行时编辑
    // filteredAgents: {
    //   handler(val) {
    //     // 可以绑定el-table @row-click事件来填充editForm
    //     console.log(val)
    //   }
    // }
  },
  mounted() {
    this.proxyList();
  }
}
</script>

<style scoped>
::v-deep .el-table .el-table__body-wrapper tbody tr.selected-row > td.el-table__cell {
  background-color: #b0b0b0 !important;
  color: #fff !important;
}
.agent-manager {
  font-family: "PingFang SC", "Helvetica Neue", Arial, "Microsoft YaHei", sans-serif;
}
.el-table th, .el-table td, .el-table tr,el-table__row {
  background: #404040 !important;
  /* color: #000 !important; */
  border-color: #656565 !important;
}
.el-table .el-table__body tr {
  background-color: rgb(101, 101, 101) !important;
}
.el-card {
  border-radius: 12px !important;
  border: none !important;
}
.round-input .el-input__inner {
  border-radius: 20px;
}

::v-deep .el-table td.el-table__cell,
::v-deep .el-table th.el-table__cell.is-leaf {
  background-color: rgb(101, 101, 101) !important;
  color: #fff !important;
}

/* 方式 1：v-deep */
::v-deep .el-table,
::v-deep .el-table th,
::v-deep .el-table td {
  border: none !important;
}

/* 如果还有伪元素残留，也可以干掉 */
::v-deep .el-table::before {
  display: none;
}

/* 去掉表头底部分割线 */
::v-deep .el-table__header-wrapper th {
  border-bottom: none !important;
}

/* 去掉表格行的分割线 */
::v-deep .el-table__row td {
  border-bottom: none !important;
}

::v-deep .el-form-item__label {
  color: #fff !important;
}

::v-deep .el-form-item {
    margin-bottom: 0px;
}

/* ::v-deep .el-input--prefix .el-input__inner {
    border-radius: 20px;
} */
</style>